import request from 'assets/js/http';

export function tagList(type) {
  // 标签 公司/notes 列表
  return request({
    url: `/tag/${type}/list`,
    method: 'post'
  });
}
export function tagSort(type, data) {
  // 标签 公司/notes 排序
  return request({
    url: `/tag/${type}/sort`,
    method: 'post',
    data
  });
}
export function tagDelete(type, data) {
  // 标签 公司/notes 删除
  return request({
    url: `/tag/${type}/delete`,
    method: 'post',
    data
  });
}
export function tagAction(type, data) {
  // 标签 公司/notes 添加/编辑
  let url = `/tag/${type}/add`;
  if (data.id || data.id === 0) {
    url = `/tag/${type}/edit`;
  }
  return request({
    url: url,
    method: 'post',
    data
  });
}
